export const COMPANY_LIST = "companies";
export const FULL_COMPANY_DETAILS = "payments/company";
export const MASTER_DETAILS = "master";
export const CC_PAYMENT = "payments/cc";
export const ACH_PAYMENT = "payments/ach";
export const COMPANY_ID_SELECTOR = "companyId=";
export const MASTER_ID_SELECTOR = "masterId=";